<div mat-dialog-content class="content">
    <!-- <h1 mat-dialog-title>Select a dealer to view their dashboard</h1> -->
    <!-- <mat-form-field class="searchbox">
        <input matInput (keyup)="searchGroups()" placeholder="Search..." [(ngModel)]="searchValue">
    </mat-form-field> -->
    <p class="header2 header-text">Your Administrators</p>
    <mat-progress-bar mode="indeterminate" *ngIf="isAdminsLoading"></mat-progress-bar>
    <app-data-table [displayedColumns]="pscAdminColumns" [tableData]="pscAdmins" [initSortColumn]="0"
            [initSortDirection]="'desc'" [selectable]="false"></app-data-table>
</div>
<div mat-dialog-actions class="button-container">
    <button mat-raised-button (click)="onNoClick()">Close</button>
</div>